import React from 'react';
import PropTypes from 'prop-types';
import { PortfolioTagIcons } from '../../modules/Portfolios/constants';

const Tag = ({ icon: Icon, label }) => {
  return (
    <div className="inline-flex items-center gap-1 text-gray-600 text-xs">
      {Icon && <Icon size={14} />}
      <span className="capitalize">{label}</span>
    </div>
  );
};

const PortfolioTags = ({ tags }) => {
  const tagsToKeep = ['asset_class', 'style', 'size'];

  const filteredTags = Object.keys(tags)
    .filter(tag => {
      // Only keep tags that are in our whitelist
      if (!tagsToKeep.includes(tag)) return false;

      // Skip if the tag value is empty, blank, or 'other'
      const tagValue = tags[tag];
      if (!tagValue ||
          tagValue.trim() === '' ||
          tagValue.toLowerCase() === 'other') {
        return false;
      }

      return true;
    });

  const getIconComponent = (tagType) => {
    const tagValue = tags[tagType]?.toLowerCase();
    // Only return icon if we have a valid tag value
    if (!tagValue || tagValue === 'other') return null;
    return PortfolioTagIcons[tagValue] || null;
  };

  return (
    <div className="flex flex-wrap items-center gap-2 text-xs">
      {filteredTags.map((tag, index) => (
        <React.Fragment key={tag}>
          <Tag
            icon={getIconComponent(tag)}
            label={tags[tag]}
          />
          {index < filteredTags.length - 1 && (
            <span className="text-gray-300">•</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

PortfolioTags.propTypes = {
  tags: PropTypes.shape({
    asset_class: PropTypes.string,
    style: PropTypes.string,
    size: PropTypes.string,
  }).isRequired,
};

export default PortfolioTags;